import script from "./SimpleModalSmall.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleModalSmall.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__